// import BannerTitle from "../font_component/banner_title/BannerTitle";

import HomeBanner from "./banner_section/HomeBanner";
import CardSection from "./card_section/CardSection";
import ProductSection from "./productsection/ProductSection";
import SwiperCard from "./swiper_card/SwiperCard";
import AboutSpirulina from "./about_spirulina/AboutSpirulina";
import ShareholderOpportunity from "./../about_us/shareholderopportunity/ShareholderOpportunity";
import SupplementBanner from "./supplement_banner/SupplementBanner";
import SpirulinaLevels from "./../about_us/spirulinalevels/SpirulinaLevels";
import TestimonialSwiper from "./testimonials_section/TestimonialSwiper";
import { useDispatch, useSelector } from "react-redux";
import { GETProfile } from "../../features/admin/auth/Slice";
import { useEffect } from "react";

function Home() {
  const dispatch = useDispatch();
  const profileDetails = useSelector(
    (state) => state?.auth?.login?.getCustomerData,
  );
  const profileStatus = useSelector(
    (state) => state?.auth?.login?.getCustomerStatus,
  );
  

  useEffect(() => {
    dispatch(GETProfile());
  }, [dispatch]);

  return (
    <>
      <HomeBanner
        profileDetails={profileDetails}
        profileStatus={profileStatus}
      />
      <CardSection />
      {/* abhishek */}
      <ProductSection />
      <SwiperCard />
      <AboutSpirulina />
      <ShareholderOpportunity />
      <SupplementBanner />
      <SpirulinaLevels />
      <TestimonialSwiper />
    </>
  );
}

export default Home;
